/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".rowlist{margin-left:0!important;margin-right:0!important;height:30px!important;line-height:30px!important}.rowOne{margin-left:0!important;margin-right:0!important}"];
export { styles as styles };
